import React from "react";


const ContactPage = () => {
  return (
    <div className="bg-black text-[#FDFFFF] p-8 flex flex-col md:flex-row justify-center items-start">
      
      {/* Text Content */}
      <div className="md:ml-8 text-left w-full md:w-1/2">
        <h1>Reach Out</h1>
        <p className="mt-4">
          Best way to contact me is at shouryasak@gmail.com. Or, use my socials from homepage.
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
